import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";

export function TemplateBuilderDropdownPreview({ question, answer, onChange, deleteComponent, addAnotherComponent }) {
    const value = useMemo(() => {
        return answer?.answer
    }, [answer]);

    const defaultValue = useMemo(() => {
        return question
            ?.options
            .find(o => o.selectedByDefault)
            ?.id;
    }, [question?.options]);

    //Load default value
    useEffect(() => {
        if (answer?.answer) {
            return;
        }

        defaultValue && handleChange(defaultValue);
    }, [answer, defaultValue]);

    const handleChange = (newValue = "") => {
        const newAnswer = {
            ...answer,
            $answerType: "Dropdown",
            questionId: question.id,
            answer: newValue,
            isAnswered: newValue !== "",
        };

        onChange(newAnswer);
    };

    return <div className="check-preview-form-field">
        <div className="check-preview-input-container">
            <select
                value={value ?? ""}
                onChange={(event) => handleChange(event.target.value)}
            >
                <option value="" disabled hidden>-- Select an Option --</option>
                {question?.options.map(option => (
                    <option key={option.id} value={option.id} >
                        {option.name}
                    </option>
                ))}
            </select>
            {deleteComponent}
        </div>
        {addAnotherComponent}
    </div>
}

TemplateBuilderDropdownPreview.propTypes = {
    answer: PropTypes.object,
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    addAnotherComponent: PropTypes.node.isRequired,
    deleteComponent: PropTypes.node.isRequired
};